import {
  fireEvent
} from "./chunk-3NKNWBNQ.mjs";

// src/events/completion-event/completion-event.ts
async function fireCompletionEvent(params, options) {
  const completionEvent = {
    _type: "v2.CompletionEvent",
    ...params
  };
  fireEvent(completionEvent, options);
}
var Completion = {
  fire: fireCompletionEvent
};

export {
  Completion
};
